import { Store } from 'src/store/index';

const getIncludeRemoveLogo = (store: Store) => store.upsell.includeRemoveLogo;
export default getIncludeRemoveLogo;
